<template>
  <div class="form form-invoice pb-4">
    <h5>{{ $t("message.contracts.document_invoice") }}</h5>
    <validation
      v-if="document_id != 'new'"
      :action="go_to_error"
      section="invoice"
      :contractId="$route.params.id"
      :item="document_id"
    />
    <br />
    <div
      class="alert mt-2 alert-success rounded d-flex"
      v-if="Invoice.IsSigned"
    >
      <span style="flex-basis: 50%">
        {{ $t("message.contracts.signed_message_" + Invoice.SignatureType) }}
        {{ Invoice.SignDate }}<br />
        {{ Invoice.SignatureName }}
      </span>
    </div>
    <span
      :class="[
        'bmd-form-group mb-2 d-block form-label-group required',
        $v.Invoice.DocumentNumber.$error ? 'has-danger' : '',
      ]"
    >
      <input
        type="text"
        class="form-control"
        v-model="Invoice.DocumentNumber"
        :placeholder="$t('message.contracts.invoice_document_number')"
        autocomplete="off"
        style="cursor: auto"
        id="invoice_document_number"
        :disabled="is_field_readonly"
      />
      <label
        for="invoice_document_number"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.invoice_document_number") }}</label
      >
      <label
        v-if="form_error && !$v.Invoice.DocumentNumber.required"
        class="control-label text-danger d-block"
        >{{ $t("message.errors.required") }}</label
      >
    </span>
    <span
      :class="[
        'bmd-form-group mb-2 d-block form-label-group required',
        $v.Invoice.DocumentDate.$error ? 'has-danger' : '',
      ]"
    >
      <!-- <b-form-datepicker :locale="locale" v-model="Invoice.DocumentDate" :placeholder="$t('message.contracts.invoice_document_date')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="invoice_document_date"></b-form-datepicker>
			<label  v-if="Invoice.DocumentDate!=''"  for="invoice_document_date" class="form-label-group-label shorter topped">{{$t('message.contracts.invoice_document_date')}}</label> -->

      <datepicker
        value-type="YYYY-MM-DD"
        format="DD.MM.YYYY"
        @focus="Invoice.DocumentDate = ' '"
        @blur="
          Invoice.DocumentDate == ' '
            ? (Invoice.DocumentDate = '')
            : (Invoice.DocumentDate = Invoice.DocumentDate)
        "
        inputClass="form-control"
        v-model="Invoice.DocumentDate"
        :placeholder="$t('message.contracts.invoice_document_date')"
        :inputAttr="{ id: 'invoice_document_date' }"
        :disabled="is_field_readonly"
      />
      <label
        for="invoice_document_date"
        class="form-label-group-label shorter"
        :class="
          Invoice.DocumentDate != '' && Invoice.DocumentDate != null
            ? 'topped'
            : ''
        "
        >{{ $t("message.contracts.invoice_document_date") }}</label
      >

      <label
        v-if="form_error && !$v.Invoice.DocumentDate.required"
        class="control-label text-danger d-block"
        >{{ $t("message.errors.required") }}</label
      >
    </span>
    <span
      :class="[
        'bmd-form-group mb-2 d-block form-label-group',
        placeholder_currency ? 'placeholderStatus' : '',
        currency_focused ? 'focused' : '',
      ]"
    >
      <v-select-popup
        type="currency"
        :placeholder="$t('message.contracts.invoice_document_currency')"
        v-model="Invoice.CurrencyCode"
        :disabled="is_field_readonly"
      />

      <!-- <v-select id="invoice_document_currency" :options="currencies" label="display_text" :class="['form-control ', typeof Invoice.CurrencyCode !== 'undefined' && Invoice.CurrencyCode.value!==''?'vs--selected':'']" v-model="Invoice.CurrencyCode" :placeholder="$t('message.contracts.invoice_document_currency')" @focus="currenciesFocused" @blur="currenciesBlurred" :disabled="is_field_readonly"></v-select>
			<label for="invoice_document_currency" class="form-label-group-label shorter">{{$t('message.contracts.invoice_document_currency')}}</label> -->
    </span>
    <span :class="['bmd-form-group mb-1 d-block form-label-group']">
      <label
        for="invoice_document_places_quantity"
        :class="[
          'form-label-group-label shorter',
          Invoice.PlacesQuantity != '' ? 'high' : '',
        ]"
        >{{ $t("message.contracts.invoice_document_places_quantity") }}</label
      >
      <cleave
        id="invoice_document_places_quantity"
        v-model="Invoice.PlacesQuantity"
        :options="cleavePQTY"
        class="form-control"
        :placeholder="$t('message.contracts.invoice_document_places_quantity')"
        autocomplete="off"
        style="cursor: auto"
        :disabled="is_field_readonly"
      ></cleave>
    </span>
    <translatable>
      <span :class="['bmd-form-group mb-2 d-block form-label-group']">
        <input
          type="text"
          class="form-control"
          v-model="Invoice.PlacesDescription"
          :placeholder="
            $t('message.contracts.invoice_document_places_description')
          "
          autocomplete="off"
          style="cursor: auto"
          id="invoice_document_places_description"
          :disabled="is_field_readonly"
        />
        <label
          for="invoice_document_places_description"
          class="form-label-group-label shorter"
          >{{
            $t("message.contracts.invoice_document_places_description")
          }}</label
        >
      </span>
    </translatable>
    <div class="row">
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="invoice_document_gross_weight"
            :class="[
              'form-label-group-label shorter',
              Invoice.GrossWeightQuantity != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.invoice_document_gross_weight") }}</label
          >
          <cleave
            id="invoice_document_gross_weight"
            v-model="Invoice.GrossWeightQuantity"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="$t('message.contracts.invoice_document_gross_weight')"
            autocomplete="off"
            style="cursor: auto"
            :disabled="is_field_readonly"
          ></cleave>
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="invoice_document_net_weight"
            :class="[
              'form-label-group-label shorter',
              Invoice.NetWeightQuantity != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.invoice_document_net_weight") }}</label
          >
          <cleave
            id="invoice_document_net_weight"
            v-model="Invoice.NetWeightQuantity"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="$t('message.contracts.invoice_document_net_weight')"
            autocomplete="off"
            style="cursor: auto"
            :disabled="is_field_readonly"
          ></cleave>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <span
          :class="[
            'bmd-form-group mb-1 d-block form-label-group',
            $v.Invoice.GCost.$error ? 'has-danger' : '',
          ]"
        >
          <label
            for="invoice_document_gcost"
            :class="[
              'form-label-group-label shorter',
              Invoice.GCost != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.invoice_document_gcost") }}</label
          >
          <cleave
            id="invoice_document_gcost"
            v-model="Invoice.GCost"
            :options="cleavePrice"
            class="form-control"
            :placeholder="$t('message.contracts.invoice_document_gcost')"
            readonly
            autocomplete="off"
            style="cursor: auto"
            :disabled="is_field_readonly"
          ></cleave>
          <label
            v-if="form_error && !$v.Invoice.GCost.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="invoice_document_discount"
            :class="[
              'form-label-group-label shorter',
              Invoice.Discount != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.invoice_document_discount") }}</label
          >
          <cleave
            id="invoice_document_discount"
            v-model="Invoice.Discount"
            :options="cleavePrice"
            class="form-control"
            :placeholder="$t('message.contracts.invoice_document_discount')"
            autocomplete="off"
            style="cursor: auto"
            :disabled="is_field_readonly"
          ></cleave>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="invoice_document_transport_charges"
            :class="[
              'form-label-group-label shorter',
              Invoice.TransportCharges != '' ? 'high' : '',
            ]"
            >{{
              $t("message.contracts.invoice_document_transport_charges")
            }}</label
          >
          <cleave
            id="invoice_document_transport_charges"
            v-model="Invoice.TransportCharges"
            :options="cleavePrice"
            class="form-control"
            :placeholder="
              $t('message.contracts.invoice_document_transport_charges')
            "
            autocomplete="off"
            style="cursor: auto"
            :disabled="is_field_readonly"
          ></cleave>
        </span>
      </div>
      <div class="col-md-4">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="invoice_document_insurance_charges"
            :class="[
              'form-label-group-label shorter',
              Invoice.InsuranceCharges != '' ? 'high' : '',
            ]"
            >{{
              $t("message.contracts.invoice_document_insurance_charges")
            }}</label
          >
          <cleave
            id="invoice_document_insurance_charges"
            v-model="Invoice.InsuranceCharges"
            :options="cleavePrice"
            class="form-control"
            :placeholder="
              $t('message.contracts.invoice_document_insurance_charges')
            "
            autocomplete="off"
            style="cursor: auto"
            :disabled="is_field_readonly"
          ></cleave>
        </span>
      </div>
      <div class="col-md-4">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="invoice_document_other_charges"
            :class="[
              'form-label-group-label shorter',
              Invoice.OtherCharges != '' ? 'high' : '',
            ]"
            >{{ $t("message.contracts.invoice_document_other_charges") }}</label
          >
          <cleave
            id="invoice_document_other_charges"
            v-model="Invoice.OtherCharges"
            :options="cleavePrice"
            class="form-control"
            :placeholder="
              $t('message.contracts.invoice_document_other_charges')
            "
            autocomplete="off"
            style="cursor: auto"
            :disabled="is_field_readonly"
          ></cleave>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <span
          :class="[
            'bmd-form-group mb-1 d-block required form-label-group',
            $v.Invoice.GCost.$error ? 'has-danger' : '',
          ]"
        >
          <label
            for="invoice_document_total_cost"
            :class="[
              'form-label-group-label shorter',
              Invoice.TotalCost > -1 ? 'high' : '',
            ]"
            >{{ $t("message.contracts.invoice_document_total_cost") }}</label
          >
          <cleave
            id="invoice_document_total_cost"
            v-model="Invoice.TotalCost"
            readonly
            :options="cleavePrice"
            class="form-control"
            :placeholder="$t('message.contracts.invoice_document_total_cost')"
            autocomplete="off"
            style="cursor: auto"
            :disabled="is_field_readonly"
          ></cleave>
          <label
            v-if="form_error && !$v.Invoice.TotalCost.required"
            class="control-label text-danger d-block"
            >{{ $t("message.errors.required") }}</label
          >
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="Invoice.PaymentPeriod"
            :placeholder="
              $t('message.contracts.invoice_document_payment_period')
            "
            maxlength="50"
            autocomplete="off"
            style="cursor: auto"
            id="invoice_document_payment_period"
            :disabled="is_field_readonly"
          />
          <label
            for="invoice_document_payment_period"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.invoice_document_payment_period")
            }}</label
          >
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-10">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group required',
                buyer_focused ? 'focused' : '',
                $v.Invoice.InvoiceByer.$error ? 'has-danger' : '',
              ]"
            >
              <v-select-popup
                type="company"
                :placeholder="$t('message.contracts.invoice_document_buyer')"
                v-model="Invoice.InvoiceByer"
                :disabled="is_field_readonly"
              />

              <!-- <v-select id="invoice_document_buyer" :options="companies" label="display_text" :class="['form-control', typeof Invoice.InvoiceByer !== 'undefined' && Invoice.InvoiceByer.value!==''?'vs--selected':'']" @search="fetchContragents"  v-model="Invoice.InvoiceByer" :placeholder="$t('message.contracts.invoice_document_buyer')" @focus="buyerFocused" @blur="buyerBlurred" :disabled="is_field_readonly"></v-select>	
	                   		<label for="invoice_document_buyer" class="form-label-group-label shorter">{{$t('message.contracts.invoice_document_buyer')}}</label> -->
              <label
                v-if="form_error && !$v.Invoice.InvoiceByer.required"
                class="control-label text-danger d-block"
                >{{ $t("message.errors.required") }}</label
              >
            </span>
          </div>
          <div class="col-2">
            <button
              v-if="!is_field_readonly"
              class="btn btn-sm btn-outline-info float-right"
              style="height: 56px; margin-top: 8px"
              @click="addByer"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-10">
            <span
              :class="[
                'bmd-form-group mb-2 mt-2 d-block form-label-group required',
                seller_focused ? 'focused' : '',
                $v.Invoice.InvoiceSeller.$error ? 'has-danger' : '',
              ]"
            >
              <v-select-popup
                type="company"
                :placeholder="$t('message.contracts.invoice_document_seller')"
                v-model="Invoice.InvoiceSeller"
                :disabled="is_field_readonly"
              />

              <!-- <v-select id="invoice_document_seller" :options="companies" label="display_text" :class="['form-control', typeof Invoice.InvoiceSeller !== 'undefined' && Invoice.InvoiceSeller.value!==''?'vs--selected':'']" @search="fetchContragents"  v-model="Invoice.InvoiceSeller" :placeholder="$t('message.contracts.invoice_document_seller')" @focus="sellerFocused" @blur="sellerBlurred" :disabled="is_field_readonly"></v-select>
		                   	<label for="invoice_document_seller" class="form-label-group-label shorter">{{$t('message.contracts.invoice_document_seller')}}</label> -->
              <label
                v-if="form_error && !$v.Invoice.InvoiceSeller.required"
                class="control-label text-danger d-block"
                >{{ $t("message.errors.required") }}</label
              >
            </span>
          </div>
          <div class="col-2">
            <button
              v-if="!is_field_readonly"
              class="btn btn-sm btn-outline-info float-right"
              style="height: 56px; margin-top: 8px"
              @click="addSeller"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <h5>{{ $t("message.contracts.invoice_products") }}</h5>
    <div id="products-table">
      <div class="input-group mb-3" style="width: 300px">
        <input
          class="form-control"
          type="text"
          v-model="looking_for_product_number"
          style="height: 32px"
          :placeholder="$t('message.contracts.search_by_number')"
        />
        <div class="input-group-append">
          <button
            @click="lookForProductByNumber"
            class="btn btn-sm btn-outline-success"
          >
            {{ $t("message.contracts.search_by_number_button") }}
          </button>
        </div>
      </div>
      <b-table
        responsive
        striped
        hover
        :items="InvoiceGoods"
        :tbody-tr-class="rowClass"
        :fields="product_fields"
        :current-page="product_page"
        :per-page="3"
      >
        <template v-slot:cell(GoodsCode)="data">
          <strong>{{ data.item.GoodsCode.display_text }}</strong>
        </template>
        <template v-slot:cell(attis_cg_quantity)="data">
          <strong
            >{{ data.value }}
            {{ data.item.attis_cg_measures.display_text }}</strong
          >
        </template>
        <template v-slot:cell(attis_cg_price)="data">
          <strong
            >{{ addThousandsSeparator(data.value, ",") }}
            {{ attis_contracts.attis_contract_currency.display_text }}</strong
          >
        </template>

        <template v-slot:cell(remove)="data">
          <button
            class="btn btn-sm btn-link text-info"
            @click="editProduct(product_page * 3 + data.index)"
          >
            <i class="fa fa-edit"></i></button
          ><button
            v-if="!is_field_readonly"
            class="btn btn-sm btn-link text-danger"
            @click="removeProduct(data.index)"
          >
            <i class="fa fa-times"></i>
          </button>
        </template>
      </b-table>
      <div class="d-flex justify-content-center">
        <b-pagination
          v-if="InvoiceGoods.length / 3 > 1"
          v-model="product_page"
          :total-rows="InvoiceGoods.length"
          :per-page="3"
        ></b-pagination>
      </div>
    </div>
    <transition name="slide">
      <div
        v-if="add_product || edit_product"
        class="add-product-block alert-success"
        style="margin: 0 -1.5em"
      >
        <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
          <input
            type="text"
            class="form-control"
            v-model="InvoiceGood.GoodMarking"
            :placeholder="$t('message.contracts.invoice_products_GoodMarking')"
            autocomplete="off"
            style="cursor: auto"
            id="invoice_products_GoodMarking"
            :disabled="is_field_readonly"
          />
          <label
            for="invoice_products_GoodMarking"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.invoice_products_GoodMarking") }}</label
          >
        </span>
        <div class="row">
          <div class="col-md-12">
            <span
              :class="[
                'bmd-form-group mb-1 d-block  form-label-group',
                placeholder_tnved ? 'placeholderStatus' : '',
                tnved_focused ? 'focused' : '',
              ]"
            >
              <tnved
                :placeholder="
                  $t('message.contracts.invoice_products_GoodsCode')
                "
                :placeholder_name="$t('message.tnved_name')"
                :placeholder_code="$t('message.tnved_code')"
                v-model="InvoiceGood.GoodsCode"
                :disabled="is_field_readonly"
              ></tnved>

              <!-- <v-select id="invoice_products_GoodsCode" :options="tnveds" label="display_text" :class="['form-control', typeof InvoiceGood.GoodsCode !== 'undefined' && InvoiceGood.GoodsCode.value!==''?'vs--selected':'']" @search="fetchTNVED"  v-model="InvoiceGood.GoodsCode" :placeholder="$t('message.contracts.invoice_products_GoodsCode')" @focus="tnvedFocused" @blur="tnvedBlurred"></v-select> -->
              <!-- <label for="invoice_products_GoodsCode" class="form-label-group-label shorter">{{$t('message.contracts.invoice_products_GoodsCode')}}</label> -->
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <translatable>
              <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
                <textarea
                  id="invoice_products_GoodsDescription"
                  :options="tnveds"
                  label="display_text"
                  :class="['form-control']"
                  v-model="InvoiceGood.GoodsDescription"
                  :placeholder="
                    $t('message.contracts.invoice_products_GoodsDescription')
                  "
                  :disabled="is_field_readonly"
                >
                </textarea>
              </span>
            </translatable>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="number"
                id="invoice_products_GoodsQuantity"
                :options="tnveds"
                label="display_text"
                :class="['form-control']"
                v-model="InvoiceGood.GoodsQuantity"
                :placeholder="
                  $t('message.contracts.invoice_products_GoodsQuantity')
                "
                :disabled="is_field_readonly"
              />
              <label
                for="invoice_products_GoodsQuantity"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.invoice_products_GoodsQuantity")
                }}</label
              >
            </span>
          </div>
          <div class="col-md-6">
            <span
              :class="[
                'bmd-form-group mb-1 d-block  form-label-group',
                placeholder_measure ? 'placeholderStatus' : '',
                measure_focused ? 'focused' : '',
              ]"
            >
              <v-select-popup
                type="measure"
                :placeholder="
                  $t(
                    'message.contracts.invoice_products_SupplementaryQualifierName',
                  )
                "
                v-model="InvoiceGood.SupplementaryQualifierName"
                :disabled="is_field_readonly"
              />

              <!-- <v-select id="invoice_products_SupplementaryQualifierName" :options="measures" label="display_text" :class="['form-control', typeof InvoiceGood.SupplementaryQualifierName !== 'undefined' && InvoiceGood.SupplementaryQualifierName.value!==''?'vs--selected':'']" @search="fetchMeasures" @focus="measureFocus" @blur="measureBlur" v-model="InvoiceGood.SupplementaryQualifierName" :placeholder="$t('message.contracts.invoice_products_SupplementaryQualifierName')" :disabled="is_field_readonly"></v-select>
							 <label for="invoice_products_SupplementaryQualifierName" class="form-label-group-label shorter">{{$t('message.contracts.invoice_products_SupplementaryQualifierName')}}</label> -->
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="invoice_products_GrossWeightQuantity"
                :class="[
                  'form-label-group-label shorter',
                  InvoiceGood.GrossWeightQuantity != '' ? 'high' : '',
                ]"
                >{{
                  $t("message.contracts.invoice_products_GrossWeightQuantity")
                }}</label
              >
              <cleave
                id="invoice_products_GrossWeightQuantity"
                v-model="InvoiceGood.GrossWeightQuantity"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="
                  $t('message.contracts.invoice_products_GrossWeightQuantity')
                "
                autocomplete="off"
                style="cursor: auto"
                :disabled="is_field_readonly"
              ></cleave>
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="invoice_products_NetWeightQuantity"
                :class="[
                  'form-label-group-label shorter',
                  InvoiceGood.NetWeightQuantity != '' ? 'high' : '',
                ]"
                >{{
                  $t("message.contracts.invoice_products_NetWeightQuantity")
                }}</label
              >
              <cleave
                id="invoice_products_NetWeightQuantity"
                v-model="InvoiceGood.NetWeightQuantity"
                :options="cleaveWeight"
                class="form-control"
                :placeholder="
                  $t('message.contracts.invoice_products_NetWeightQuantity')
                "
                autocomplete="off"
                style="cursor: auto"
                :disabled="is_field_readonly"
              ></cleave>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <span
              :class="[
                'bmd-form-group mb-1 d-block form-label-group',
                $v.InvoiceGood.Price.$error ? 'has-danger' : '',
              ]"
            >
              <label
                for="invoice_products_Price"
                :class="[
                  'form-label-group-label shorter',
                  InvoiceGood.Price != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.invoice_products_Price") }}</label
              >
              <cleave
                id="invoice_products_Price"
                v-model="InvoiceGood.Price"
                :options="cleavePrice"
                class="form-control"
                :placeholder="$t('message.contracts.invoice_products_Price')"
                autocomplete="off"
                style="cursor: auto"
                :disabled="is_field_readonly"
              ></cleave>
              <label
                v-if="product_error && !$v.InvoiceGood.Price.required"
                class="control-label text-danger d-block"
                >{{ $t("message.errors.required") }}</label
              >
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="invoice_products_Discount"
                :class="[
                  'form-label-group-label shorter',
                  InvoiceGood.Discount != '' ? 'high' : '',
                ]"
                >{{ $t("message.contracts.invoice_products_Discount") }}</label
              >
              <cleave
                id="invoice_products_Discount"
                v-model="InvoiceGood.Discount"
                :options="cleavePrice"
                class="form-control"
                :placeholder="$t('message.contracts.invoice_products_Discount')"
                autocomplete="off"
                style="cursor: auto"
                :disabled="is_field_readonly"
              ></cleave>
            </span>
          </div>
          <div class="col-md-6">
            <span :class="['bmd-form-group mb-1 d-block  form-label-group']">
              <input
                type="number"
                id="invoice_products_DiscountPercentage"
                max="100"
                min="0"
                :class="['form-control']"
                v-model="InvoiceGood.DiscountPercentage"
                :placeholder="
                  $t('message.contracts.invoice_products_DiscountPercentage')
                "
                @focus="
                  percent_focused = true;
                  discount_focused = false;
                "
                @blur="percent_focused = false"
                :disabled="is_field_readonly"
              />
              <label
                for="invoice_products_DiscountPercentage"
                class="form-label-group-label shorter"
                >{{
                  $t("message.contracts.invoice_products_DiscountPercentage")
                }}</label
              >
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <span
              :class="[
                'bmd-form-group mb-1 d-block  form-label-group',
                country_focused ? 'focused' : '',
              ]"
            >
              <v-select-popup
                type="country"
                :placeholder="
                  $t('message.contracts.invoice_products_OriginCountryCode')
                "
                v-model="InvoiceGood.OriginCountryCode"
                :disabled="is_field_readonly"
              />
              <!-- <v-select id="invoice_products_OriginCountryCode" :options="countries" label="display_text" :class="['form-control', typeof InvoiceGood.OriginCountryCode !== 'undefined' && InvoiceGood.OriginCountryCode.value!==''?'vs--selected':'']" @search="fetchCountries" @focus="countryFocus" @blur="countryBlur" v-model="InvoiceGood.OriginCountryCode" :placeholder="$t('message.contracts.invoice_products_OriginCountryCode')" :disabled="is_field_readonly"></v-select>
							 <label for="invoice_products_OriginCountryCode" class="form-label-group-label shorter">{{$t('message.contracts.invoice_products_OriginCountryCode')}}</label> -->
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="invoice_products_ServiceCharges"
                :class="[
                  'form-label-group-label shorter',
                  InvoiceGood.ServiceCharges != '' ? 'high' : '',
                ]"
                >{{
                  $t("message.contracts.invoice_products_ServiceCharges")
                }}</label
              >
              <cleave
                id="invoice_products_ServiceCharges"
                v-model="InvoiceGood.ServiceCharges"
                :options="cleavePrice"
                class="form-control"
                :placeholder="
                  $t('message.contracts.invoice_products_ServiceCharges')
                "
                autocomplete="off"
                style="cursor: auto"
                :disabled="is_field_readonly"
              ></cleave>
            </span>
          </div>
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="invoice_products_TransportCharges"
                :class="[
                  'form-label-group-label shorter',
                  InvoiceGood.TransportCharges != '' ? 'high' : '',
                ]"
                >{{
                  $t("message.contracts.invoice_products_TransportCharges")
                }}</label
              >
              <cleave
                id="invoice_products_TransportCharges"
                v-model="InvoiceGood.TransportCharges"
                :options="cleavePrice"
                class="form-control"
                :placeholder="
                  $t('message.contracts.invoice_products_TransportCharges')
                "
                autocomplete="off"
                style="cursor: auto"
                :disabled="is_field_readonly"
              ></cleave>
            </span>
          </div>
          <div class="col-md-4">
            <span :class="['bmd-form-group mb-1 d-block form-label-group']">
              <label
                for="invoice_products_OtherCharges"
                :class="[
                  'form-label-group-label shorter',
                  InvoiceGood.OtherCharges != '' ? 'high' : '',
                ]"
                >{{
                  $t("message.contracts.invoice_products_OtherCharges")
                }}</label
              >
              <cleave
                id="invoice_products_OtherCharges"
                v-model="InvoiceGood.OtherCharges"
                :options="cleavePrice"
                class="form-control"
                :placeholder="
                  $t('message.contracts.invoice_products_OtherCharges')
                "
                autocomplete="off"
                style="cursor: auto"
                :disabled="is_field_readonly"
              ></cleave>
            </span>
          </div>
        </div>
        <div v-if="add_product">
          <button
            id="product-add-modal-btn"
            class="btn btn-sm btn-success"
            @click="addProduct()"
            v-if="add_product && !is_field_readonly"
          >
            {{ $t("message.contracts.add_product") }}
          </button>
          <button
            class="btn btn-sm btn-danger btn-outline-danger float-right"
            @click="hideAddProduct()"
          >
            {{ $t("message.cancel") }}
          </button>
        </div>
        <div v-if="edit_product">
          <button
            class="btn btn-sm btn-success"
            @click="saveProduct()"
            v-if="edit_product && !is_field_readonly"
          >
            {{ $t("message.contracts.save_product") }}
          </button>
          <button
            class="btn btn-sm btn-danger btn-outline-danger float-right"
            @click="hideEditProduct()"
          >
            {{ $t("message.cancel") }}
          </button>
        </div>
      </div>
    </transition>
    <button
      id="product-add-to-invoice-btn"
      class="btn btn-sm btn-success btn-outline-success mb-3"
      @click="showAddProduct()"
      v-if="!add_product && !is_field_readonly"
    >
      {{ $t("message.contracts.add_product") }}
    </button>
    <div v-if="!add_product && !is_field_readonly" class="form-group">
      <label for="excel-goods-import">{{
        $t("message.contracts.excel_import_gooods_label")
      }}</label>
      <input
        type="file"
        id="excel-goods-import"
        :disabled="files_loading"
        class="form-control"
        @change="importGoodsExcel($event, index)"
      />
    </div>

    <b-modal
      id="modal-add-buyer"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.add_buyer')"
      button-size="lg"
    >
      <buyer-seller-form
        type="buyer"
        :disabled="is_field_readonly"
      ></buyer-seller-form>
    </b-modal>
    <b-modal
      id="modal-add-seller"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.add_seller')"
      button-size="lg"
    >
      <buyer-seller-form
        type="seller"
        :disabled="is_field_readonly"
      ></buyer-seller-form>
    </b-modal>
    <div
      class="buttons"
      style="position: absolute; bottom: 16px; right: 20%; left: 20px; margin: 0 3px;"
    >
      <div class="dropdown">
        <button
          v-if="!is_field_readonly"
          class="btn btn-outline-success btn-sm dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          :disabled="buttons_loading"
        >
          {{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}&nbsp;&nbsp;
          <div
            class="loading loading-button"
            v-if="loading"
            style="
              border-top-width: 2px;
              border-top-color: #4caf50;
              top: 30px;
              right: -93px;
            "
          ></div>
        </button>
        <div
          class="dropdown-menu"
          name="create-invoice-dropdown-button"
          aria-labelledby="dropdownMenuButton"
        >
          <a
            name="create-invoice-add-button"
            class="dropdown-item"
            style="color: #4caf50"
            @click="saveDocument(false)"
            :disabled="buttons_loading"
            >{{
              $t(
                is_new
                  ? "message.contracts.document_create"
                  : "message.contracts.document_save",
              )
            }}</a
          >
          <a
            class="dropdown-item"
            style="color: #4caf50"
            @click="saveDocument(true)"
            :disabled="buttons_loading"
            >{{
              $t(
                is_new
                  ? "message.contracts.document_create_validate"
                  : "message.contracts.document_save_validate",
              )
            }}</a
          >
          <a
            class="dropdown-item"
            style="color: #4caf50"
            v-if="!is_new"
            @click="submit_and_sign_dialog()"
            :disabled="buttons_loading"
            >{{ $t("message.contracts.submit_and_sign_button") }}</a
          >
        </div>
      </div>
      <!--<button class="btn btn-success float-left" @click="saveDocument(false)" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create':'message.contracts.document_save')}}</button>
			<button class="btn btn-success float-left" @click="saveDocument(true)" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create_validate':'message.contracts.document_save_validate')}}</button> -->
      <!--<button v-if="!is_new" class="btn btn-success float-left" @click="submit_and_sign_dialog()" :disabled=buttons_loading>{{$t('message.contracts.submit_and_sign_button')}}</button> -->
      <!-- <button class="btn btn-info float-right" @click="exportEfreight()">e-Freight</button> -->
    </div>
    <b-modal
      id="modal-select-ecp-type-invoice"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.select_ecp_type')"
    >
      <div class="text-center" v-if="!show_code_sign_type">
        <button
          class="btn btn-outline-success btn-round"
          @click="signDocument()"
        >
          {{ $t("message.contracts.sign_with_ecp") }}
        </button>
        <div>
          <small>
            <i>
              {{ $t("message.contracts.only_for_kz") }}
            </i>
          </small>
        </div>
        <hr />
        <button
          class="btn btn-outline-success btn-round"
          @click="sign_with_code()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
      </div>
      <div class="text-center" v-if="show_code_sign_type">
        <div class="form-group">
          <label for="input-code">
            {{ $t("message.contracts.input_signature_code") }}
          </label>
          <input
            type="text"
            class="form-control"
            id="input-code"
            v-model="sign_with_code_code"
          />
        </div>
        <button
          class="btn btn-success btn-round"
          @click="sign_with_code_phase2()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
        <hr />
        <button
          class="btn btn-default btn-round btn-sm"
          @click="show_code_sign_type = false"
        >
          {{ $t("message.cancel") }}
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
var querystring = require("querystring");
import { required } from "vuelidate/lib/validators";
export default {
  props: ["goods", "contract_details", "document_id", "is_new", "document"],
  data() {
    return {
      files_loading: false,
      looking_for_product_number: "",
      product_page: 0,
      show_code_sign_type: false,
      sign_with_code_code: "",

      buttons_loading: false,
      loading: false,

      add_product: false,
      edit_product: false,
      currently_editing: false,
      form_error: false,
      product_error: false,
      currency_focused: false,
      placeholder_currency: false,
      buyer_focused: false,
      seller_focused: false,
      tnved_focused: false,
      placeholder_tnved: false,
      placeholder_measure: false,
      measure_focused: false,
      country_focused: false,
      currencies: [],
      measures: [],
      companies: [],
      countries: [],
      tnveds: [],

      percent_focused: false,
      discount_focused: false,

      cleavePQTY: {
        numeral: false,
        numericOnly: true,
        numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [8],
      },
      cleaveWeight: {
        numeral: true,
        // numericOnly: true,
        // numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [24],
        numeralDecimalScale: 6,
      },
      cleavePrice: {
        numeral: true,
        // numericOnly: true,
        // numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [20],
        numeralDecimalScale: 2,
      },

      Invoice: {
        DocumentNumber: "",
        DocumentDate: "",
        CurrencyCode: "",
        PlacesQuantity: "",
        PlacesDescription: "",
        GrossWeightQuantity: "",
        NetWeightQuantity: "",
        GCost: "",
        Discount: "",
        TransportCharges: "",
        InsuranceCharges: "",
        OtherCharges: "",
        TotalCost: "",
        PaymentPeriod: "",
        InvoiceByer: { value: "" },
        InvoiceSeller: { value: "" },
        IsSigned: false,
        SignatureType: "",
        SignDate: "",
        SignatureName: "",
      },
      InvoiceGoods: [],
      InvoiceGood: {
        GoodMarking: "",
        GoodsCode: { value: "" },
        GoodsDescription: "",
        GoodsQuantity: "",
        SupplementaryQualifierName: { value: "" },
        GrossWeightQuantity: "",
        NetWeightQuantity: "",
        Price: "",
        Discount: "",
        DiscountPercentage: "",
        OriginCountryCode: { value: "" },
        ServiceCharge: "",
        TransportCharges: "",
        OtherCharges: "",
      },
      product_fields: [
        {
          key: "good_no",
          label: this.$t("message.contracts.product_number"),
          sortable: false,
        },
        {
          key: "GoodMarking",
          label: this.$t("message.contracts.invoice_products_GoodMarking"),
          sortable: false,
        },
        {
          key: "GoodsCode",
          label: this.$t("message.contracts.invoice_products_GoodsCode"),
          sortable: false,
        },
        {
          key: "Price",
          label: this.$t("message.contracts.invoice_products_Price"),
          sortable: false,
        },
        {
          key: "GoodsQuantity",
          label: this.$t("message.contracts.invoice_products_GoodsQuantity"),
          sortable: false,
        },
        {
          key: "GrossWeightQuantity",
          label: this.$t(
            "message.contracts.invoice_products_GrossWeightQuantity",
          ),
          sortable: true,
        },
        {
          key: "NetWeightQuantity",
          label: this.$t(
            "message.contracts.invoice_products_NetWeightQuantity",
          ),
          sortable: false,
        },
        {
          key: "remove",
          label: "",
        },
      ],
    };
  },
  methods: {
    /**
     * determines if the row should be highlighted
     */
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (parseInt(item.good_no) === parseInt(this.looking_for_product_number))
        return "table-success";
    },
    /**
     * looks for product in the grid by its guid
     */
    lookForProductByNumber() {
      let index =
        this.InvoiceGoods.findIndex(
          (good) =>
            parseInt(good.good_no) == parseInt(this.looking_for_product_number),
        ) + 1;
      if (!index) index = this.looking_for_product_number;

      const page = Math.ceil(index / 3);
      this.product_page = page;
    },
    /**
     * finds absolute position of the element
     */
    findPos(obj) {
      var curleft = 0;
      var curtop = 0;

      if (obj.offsetParent) {
        do {
          curleft += obj.offsetLeft;
          curtop += obj.offsetTop;
        } while ((obj = obj.offsetParent));

        return { X: curleft, Y: curtop };
      }
    },
    is_field_readonly() {
      console.log("invoice signed");
      console.log(this.Invoice.IsSigned);
      if (this.Invoice.IsSigned) return true;
      return false;
    },
    /**
     * replaces data-name of the field with field ID for validation purposes
     */
    field_name_replace(input) {
      let replaces = {
        attis_contract_desc: "contract_description",
        attis_contract_subject: "contract_subject",
      };
      return replaces[input];
    },
    /**
     * Navigates user to the field with error
     */
    go_to_error(error) {
      document.querySelector("#products-table").classList.remove("error");
      this.show_banks_error = false;
      this.show_founder_error = false;
      // switch(error.Subsection){
      // 	case 'Invoice':
      console.log("tikrinam tipa ir id");
      console.log(error.Subsection + " " + error.Id + " " + this.document_id);
      if (error.Subsection == "Invoice" && error.Id == this.document_id) {
        switch (error.Value) {
          case "Invoice.DocumentDate":
            var element = document.querySelector("#invoice_document_date");
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.focus();
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
          case "Invoice.CurrencyCode":
            var element = document.querySelector("#invoice_document_currency");
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.querySelector("input").focus();
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
          case "Invoice.GrossWeightQuantity":
            var element = document.querySelector(
              "#invoice_document_gross_weight",
            );
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.focus();
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
          case "Invoice.NetWeightQuantity":
            var element = document.querySelector(
              "#invoice_document_net_weight",
            );
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.focus();
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
          case "Invoice.TotalCost":
            var element = document.querySelector(
              "#invoice_document_total_cost",
            );
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.focus();
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
          case "InvoiceByer<>attis_contract_owner":
            var element = document.querySelector("#invoice_document_buyer");
            var element_pos = this.findPos(element);
            // element.parentNode.classList.add('error')
            element.querySelector("input").focus();
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
          case "attis_cg_price":
          case "GoodMarking <> attis_cg_good_name":
          case "GoodsCode <> attis_cg_TNVED":
            var element = document.querySelector("#products-table");
            var element_pos = this.findPos(element);
            element.classList.add("error");
            // element.focus()
            document
              .querySelector("#modal-document")
              .scrollTo(0, element_pos.Y - 50);
            break;
        }
      } else {
        setTimeout(() => {
          error.closeFie = true;
          this.$root.$emit("process_contract_error", error);
        }, 500);
      }
    },
    /**
     * get contract XML and sends it to backend along with token from e-mail to sign data
     * after signing it gets the signature code and sends it back to the backend
     * to store signature in document
     */
    sign_with_code_phase2() {
      if (this.sign_with_code_code != "") {
        axios
          .get(
            window.base + "/document/LoadInvoiceXML?doc_id=" + this.document_id,
          )
          .then((response) => {
            var fd = new FormData();
            var xml = response.data.replace(
              '<?xml version="1.0" encoding="utf-16"?>',
              "",
            );
            fd.append("token", this.sign_with_code_code);
            fd.append("data", xml);
            axios
              .post(window.base + "/account/SignData", fd)
              .then((response) => {
                var fd = new FormData();
                fd.append("contract_id", this.document_id);
                fd.append("signature", response.data);
                axios
                  .post(window.base + "/document/AddDocumentSignature", fd)
                  .then(() => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "success",
                      text: this.$root.$t("message.message.contract_signed"),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-invoice");
                  })
                  .catch((e) => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$root.$t(
                        "message.message.contract_not_signed",
                      ),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide("modal-select-ecp-type-invoice");
                  });
              });
          });
      }
    },
    /**
     * Sends request to backend to send a code to sign a document without ECP
     */
    sign_with_code() {
      axios
        .get(window.base + "/account/GenerateToken?doc_id=" + this.document_id)
        .then((response) => {
          console.log(response.data);
          this.show_code_sign_type = true;
        });
    },
    /**
     * Displays a dialog to select which method of electronic signature fits user the best.
     */
    submit_and_sign_dialog() {
      this.$bvModal.show("modal-select-ecp-type-invoice");
    },
    /**
     * Initializes electorinc signature for the document.
     * Gets XML from backend.
     * Signs with NCA Layer.
     * Sends signature back to backend to store for future comparison.
     */
    signDocument() {
      this.loading = true;
      axios
        .get(
          window.base + "/document/LoadInvoiceXML?doc_id=" + this.document_id,
        )
        .then((response) => {
          this.xml = response.data.replace(
            '<?xml version="1.0" encoding="utf-16"?>',
            "",
          );
          window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
          window.callback = null;

          window.webSocket.onopen = (event) => {
            window.signXml("PKCS12", "SIGNATURE", this.xml, () => {});
          };

          window.webSocket.onclose = function (event) {
            if (event.wasClean) {
            } else {
              openDialog();
            }
          };

          window.webSocket.onmessage = (event) => {
            var result = JSON.parse(event.data);
            if (result != null) {
              var rw = {
                code: result["code"],
                message: result["message"],
                responseObject: result["responseObject"],
                getResult: function () {
                  return this.result;
                },
                getMessage: function () {
                  return this.message;
                },
                getResponseObject: function () {
                  return this.responseObject;
                },
                getCode: function () {
                  return this.code;
                },
              };
              if (rw.code == "200") {
                var oParser = new DOMParser();
                var oDOM = oParser.parseFromString(
                  rw.getResponseObject(),
                  "application/xml",
                );
                var value =
                  oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
                var certificate =
                  oDOM.getElementsByTagName("ds:X509Certificate")[0].innerHTML;

                axios
                  .get(window.base + "/account/loadSignatureDetails")
                  .then((response) => {
                    let cert = response.data.cert.replace(
                      /(?:\r\n|\r|\n)/g,
                      "",
                    );
                    if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, "")) {
                      var fd = new FormData();
                      let name = response.data.cert_name;
                      fd.append("document_id", this.document_id);
                      fd.append("contract_id", this.document_id);
                      fd.append("signature", value);
                      fd.append("signature_name", name);
                      fd.append("type", "signature");
                      axios
                        .post(
                          window.base + "/document/AddDocumentSignature",
                          fd,
                        )
                        .then(() => {
                          this.loading = false;
                          this.load(); //refresh status of the contract
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.document_signed"),
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-invoice");
                        })
                        .catch((e) => {
                          this.loading = false;
                          new Noty({
                            theme: "light",
                            type: "error",
                            text:
                              this.$t("message.message.document_not_signed") +
                              " (" +
                              e +
                              ")",
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide("modal-select-ecp-type-invoice");
                        });
                    } else {
                      this.loading = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t(
                          "message.message.document_not_signed_cert_invalid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });

                // var fd = new FormData;
                // fd.append('contract_id', this.document_id)
                // fd.append('signature', value)
                // axios.post(window.base + '/document/AddDocumentSignature', fd).then(()=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'success',
                // 		text: this.$root.$t('message.message.document_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // }).catch(e=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'error',
                // 		text: this.$root.$t('message.message.document_not_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // })
                window.webSocket.close();
                // window.webSocket.removeEventListener('message', {})
              }
            }
          };
        });
    },
    exportEfreight() {
      axios
        .get(window.base + "/document/xmlepi?id=" + this.document_id)
        .then((response) => {
          this.$root.$emit("loadDocuments", { category: "all" });
          this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
          this.$root.$emit("bv::hide::modal", "modal-document-new", "#btnShow");
        });
    },
    addByer() {
      this.$bvModal.show("modal-add-buyer");
    },
    addSeller() {
      this.$bvModal.show("modal-add-seller");
    },
    findLibValueProduct(lib, value, field, index) {
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (
                item.value.trim().toLowerCase() == value.trim().toLowerCase()
              ) {
                this.$set(this.InvoiceGoods[index], field, item);
              }
            });
          });
      }
    },
    findLibValue(lib, value, field) {
      if (typeof lib == "string") {
        axios
          .get(
            window.base +
              "/library?type=" +
              lib +
              "&query=&qty=1000" +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            response.data.forEach((item) => {
              if (
                item.value.trim().toLowerCase() == value.trim().toLowerCase()
              ) {
                this.$set(this.Invoice, field, item);
              }
            });
          });
      } else {
        lib.forEach((item) => {
          if (item.value.trim().toLowerCase() == value.trim().toLowerCase())
            this.$set(this.Invoice, field, item);
        });
      }
    },
    saveProduct() {
      // this.$v.$touch('InvoiceGood')
      if (this.$v.InvoiceGood.$invalid) {
        this.product_error = true;
        setTimeout(() => {
          if ($(".has-danger").length > 0)
            $("html,body").animate(
              { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
              1000,
            );
        }, 100);
      } else {
        this.product_error = false;
        this.hideEditProduct();
      }
    },
    hideEditProduct() {
      this.InvoiceGood = {
        GoodMarking: "",
        GoodsCode: { display_text: "", value: "" },
        GoodsDescription: "",
        GoodsQuantity: "",
        SupplementaryQualifierName: { value: "", display_text: "" },
        GrossWeightQuantity: "",
        NetWeightQuantity: "",
        Price: "",
        Discount: "",
        DiscountPercentage: "",
        OriginCountryCode: { value: "", display_text: "" },
        ServiceCharges: "",
        TransportCharges: "",
        OtherCharges: "",
      };
      this.edit_product = false;
    },
    editProduct(index) {
      this.edit_product = true;
      this.InvoiceGood = this.InvoiceGoods[index];
      this.currently_editing = index;
    },
    removeProduct(index) {
      this.InvoiceGoods.splice(index, 1);
    },
    addProduct() {
      this.$v.$touch("InvoiceGood");
      if (this.$v.InvoiceGood.$invalid) {
        this.product_error = true;
        setTimeout(() => {
          $("html,body").animate(
            { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
            1000,
          );
        }, 100);
      } else {
        this.product_error = false;

        this.InvoiceGoods.push({
          good_no: this.InvoiceGoods.length + 1,
          GoodMarking: this.InvoiceGood.GoodMarking,
          GoodsCode: this.InvoiceGood.GoodsCode,
          GoodsDescription: this.InvoiceGood.GoodsDescription,
          GoodsQuantity: this.InvoiceGood.GoodsQuantity,
          SupplementaryQualifierName:
            this.InvoiceGood.SupplementaryQualifierName,
          GrossWeightQuantity: this.InvoiceGood.GrossWeightQuantity,
          NetWeightQuantity: this.InvoiceGood.NetWeightQuantity,
          Price: this.InvoiceGood.Price,
          Discount: this.InvoiceGood.Discount,
          DiscountPercentage: this.InvoiceGood.DiscountPercentage,
          OriginCountryCode: this.InvoiceGood.OriginCountryCode,
          ServiceCharges: this.InvoiceGood.ServiceCharges,
          TransportCharges: this.InvoiceGood.TransportCharges,
          OtherCharges: this.InvoiceGood.OtherCharges,
        });
        this.hideAddProduct();
      }
    },
    showAddProduct() {
      this.add_product = true;
    },
    hideAddProduct() {
      this.add_product = false;
      this.InvoiceGood = {
        GoodMarking: "",
        GoodsCode: { display_text: "", value: "" },
        GoodsDescription: "",
        GoodsQuantity: "",
        SupplementaryQualifierName: { value: "", display_text: "" },
        GrossWeightQuantity: "",
        NetWeightQuantity: "",
        Price: "",
        Discount: "",
        DiscountPercentage: "",
        OriginCountryCode: { value: "", display_text: "" },
        ServiceCharges: "",
        TransportCharges: "",
        OtherCharges: "",
      };
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
        });
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 10000);
    },
    fetchTNVED(search, loading) {
      this.getLibrary("tnved", search, 10000);
    },
    fetchMeasures(search, loading) {
      this.getLibrary("measure", search, 10000);
    },
    fetchCurrencies() {
      this.getLibrary("currency", "", 10000);
    },
    fetchContragents(search, loading) {
      this.getLibrary("company", search, 10000);
    },
    currenciesFocused() {
      this.currency_focused = true;
    },
    currenciesBlurred() {
      this.currency_focused = false;
      // this.validateField('company_status')
    },
    buyerFocused() {
      this.buyer_focused = true;
    },
    buyerBlurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    sellerFocused() {
      this.buyer_focused = true;
    },
    sellerBlurred() {
      this.buyer_focused = false;
      // this.validateField('company_status')
    },
    tnvedFocused() {
      this.tnved_focused = true;
    },
    tnvedBlurred() {
      this.tnved_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    measureFocus() {
      this.measure_focused = true;
    },
    measureBlur() {
      this.measure_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    countryFocus() {
      this.country_focused = true;
    },
    countryBlur() {
      this.country_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
    findTNVED(code, index) {
      axios
        .get(
          window.base +
            "/library/tnved?code=" +
            code +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          if (typeof response.data[0] !== "undefined")
            this.$set(this.InvoiceGoods[index], "GoodsCode", response.data[0]);
          // this.$set(this.attis_contract_goods[index], 'attis_cg_TNVED', response.data[0])
        });
    },
    load() {
      axios
        .get(window.base + "/Document/LoadInvoice/?doc_id=" + this.document_id)
        .then((response) => {
          this.$emit("file", response.data.files);
          this.Invoice.DocumentNumber = response.data.DocumentNumber;
          this.Invoice.DocumentDate = response.data.DocumentDate;
          this.findLibValue(
            "currency",
            response.data.CurrencyCode,
            "CurrencyCode",
          );
          this.Invoice.PlacesQuantity = response.data.PlacesQuantity;
          this.Invoice.PlacesDescription =
            response.data.PlacesDescription.trim();
          this.Invoice.GrossWeightQuantity = response.data.GrossWeightQuantity;
          this.Invoice.NetWeightQuantity = response.data.NetWeightQuantity;
          this.Invoice.GCost = response.data.GCost;
          this.Invoice.Discount = response.data.Discount;
          this.Invoice.TransportCharges = response.data.TransportCharges;
          this.Invoice.InsuranceCharges = response.data.InsuranceCharges;
          this.Invoice.OtherCharges = response.data.OtherCharges;
          this.Invoice.TotalCost = response.data.TotalCost;
          this.Invoice.PaymentPeriod = response.data.PaymentPeriod;
          console.log("is signed");
          console.log(response.data.IsSigned);
          if (response.data.IsSigned == true) this.Invoice.IsSigned = true;
          this.Invoice.SignatureType = response.data.SignatureType;
          this.Invoice.SignDate = response.data.SignDate;
          this.Invoice.SignatureName = response.data.SignatureName;
          axios
            .get(
              window.base +
                "/document/getFirmDetails?bin=" +
                response.data.InvoiceByer,
            )
            .then((response_) => {
              this.Invoice.InvoiceByer = {
                value: response.data.InvoiceByer,
                display_text: response_.data.org_name,
              };
            });
          axios
            .get(
              window.base +
                "/document/getFirmDetails?bin=" +
                response.data.InvoiceSeller,
            )
            .then((response_) => {
              this.Invoice.InvoiceSeller = {
                value: response.data.InvoiceSeller,
                display_text: response_.data.org_name,
              };
            });
          // this.findLibValue('company', response.data.InvoiceByer, 'InvoiceByer')
          // this.findLibValue('company', response.data.InvoiceSeller, 'InvoiceSeller')
          // this.Invoice.InvoiceByer = response.data.InvoiceByer
          // this.Invoice.InvoiceSeller = response.data.InvoiceSeller
          // console.log(response.data.product)
          response.data.product.forEach((good, index) => {
            var tmp_good = {
              good_no: good.good_no,
              good_guid: good.good_guid,
              GoodMarking: good.GoodMarking,
              GoodsDescription: good.GoodsDescription,
              GoodsQuantity: good.GoodsQuantity,
              GrossWeightQuantity: good.GrossWeightQuantity,
              NetWeightQuantity: good.NetWeightQuantity,
              Price: good.Price,
              Discount: good.Discount,
              DiscountPercentage: good.DiscountPercentage,
              ServiceCharges: good.ServiceCharges,
              TransportCharges: good.TransportCharges,
              OtherCharges: good.OtherCharges,
              GoodsCode: { value: good.GoodsCode, display_text: "" },
            };
            this.InvoiceGoods.push(tmp_good);
            this.findTNVED(good.GoodsCode, index);
            // this.findLibValueProduct('tnved', good.GoodsCode, 'GoodsCode', index)
            this.findLibValueProduct(
              "country",
              good.OriginCountryCode,
              "OriginCountryCode",
              index,
            );
            this.findLibValueProduct(
              "measure",
              good.SupplementaryQualifierName,
              "SupplementaryQualifierName",
              index,
            );
          });
        });
    },
    stringifyProducts() {
      var result = [];
      this.InvoiceGoods.forEach((product, index) => {
        var line = "";

        line = "product[" + index + "].GoodMarking=" + product.GoodMarking;
        line +=
          "&product[" +
          index +
          "].GoodsDescription=" +
          product.GoodsDescription;
        line +=
          "&product[" + index + "].GoodsQuantity=" + product.GoodsQuantity;
        line +=
          "&product[" +
          index +
          "].GrossWeightQuantity=" +
          product.GrossWeightQuantity;
        line +=
          "&product[" +
          index +
          "].NetWeightQuantity=" +
          product.NetWeightQuantity;
        line += "&product[" + index + "].Price=" + product.Price;
        line += "&product[" + index + "].Discount=" + product.Discount;
        line +=
          "&product[" +
          index +
          "].DiscountPercentage=" +
          product.DiscountPercentage;
        line +=
          "&product[" + index + "].ServiceCharges=" + product.ServiceCharges;
        line +=
          "&product[" +
          index +
          "].TransportCharges=" +
          product.TransportCharges;
        line += "&product[" + index + "].OtherCharges=" + product.OtherCharges;
        if (typeof product.GoodsCode !== "undefined")
          line +=
            "&product[" + index + "].GoodsCode=" + product.GoodsCode.value;
        if (typeof product.OriginCountryCode !== "undefined")
          line +=
            "&product[" +
            index +
            "].OriginCountryCode=" +
            product.OriginCountryCode.value;
        if (typeof product.SupplementaryQualifierName !== "undefined")
          line +=
            "&product[" +
            index +
            "].SupplementaryQualifierName=" +
            product.SupplementaryQualifierName.value;

        result.push(line);
      });
      return result.join("&");
    },
    saveDocument(validate) {
      var data = {
        document: this.document,
      };
      // this.$v.$touch()
      if (this.$v.Invoice.$invalid) {
        this.form_error = true;
        setTimeout(() => {
          if ($(".has-danger").length > 0)
            $("html,body").animate(
              { scrollTop: $(".has-danger").eq(0).offset().top - 50 },
              1000,
            );
        }, 100);
      } else {
        if (!validate) {
          this.$root.$emit("show-loading");
          this.buttons_loading = true;
        }

        var tmp = JSON.parse(JSON.stringify(this.Invoice));
        if (typeof tmp.CurrencyCode !== "undefined") {
            tmp.CurrencyCode = tmp.CurrencyCode.value;
        }
          
        if (typeof tmp.InvoiceByer !== "undefined") {
            tmp.InvoiceByer = tmp.InvoiceByer.value;
        }

        if (typeof tmp.InvoiceSeller !== "undefined") {
            tmp.InvoiceSeller = tmp.InvoiceSeller.value;
        }

        //if(typeof data.document.attis_contract_doc_type!=='undefined')
        //data.document.attis_contract_doc_type = data.document.attis_contract_doc_type.value
        var formData = new FormData();
        for (var i in tmp) {
          formData.append(i, tmp[i]);
        }
        formData.append("document_category", "finance");
        this.InvoiceGoods.forEach((product, index) => {
          formData.append("product[" + index + "].good_no", product.good_no);
          formData.append(
            "product[" + index + "].good_guid",
            product.good_guid,
          );
          formData.append(
            "product[" + index + "].GoodMarking",
            product.GoodMarking,
          );
          formData.append(
            "product[" + index + "].GoodsDescription",
            product.GoodsDescription,
          );
          formData.append(
            "product[" + index + "].GoodsQuantity",
            product.GoodsQuantity,
          );
          formData.append(
            "product[" + index + "].GrossWeightQuantity",
            product.GrossWeightQuantity,
          );
          formData.append(
            "product[" + index + "].NetWeightQuantity",
            product.NetWeightQuantity,
          );
          formData.append("product[" + index + "].Price", product.Price);
          formData.append("product[" + index + "].Discount", product.Discount);
          formData.append(
            "product[" + index + "].DiscountPercentage",
            product.DiscountPercentage,
          );
          formData.append(
            "product[" + index + "].ServiceCharges",
            product.ServiceCharges,
          );
          formData.append(
            "product[" + index + "].TransportCharges",
            product.TransportCharges,
          );
          formData.append(
            "product[" + index + "].OtherCharges",
            product.OtherCharges,
          );
          if (typeof product.GoodsCode !== "undefined")
            formData.append(
              "product[" + index + "].GoodsCode",
              product.GoodsCode.value,
            );
          if (typeof product.OriginCountryCode !== "undefined")
            formData.append(
              "product[" + index + "].OriginCountryCode",
              product.OriginCountryCode.value,
            );
          if (typeof product.SupplementaryQualifierName !== "undefined")
            formData.append(
              "product[" + index + "].SupplementaryQualifierName",
              product.SupplementaryQualifierName.value,
            );
        });
        // Attach file
        formData.append("file", data.document.file);
        // console.log(tmp, data.document, this.stringifyProducts())
        var t1 = this.$t("message.error");
        axios
          .post(
            window.base +
              (this.is_new === true
                ? "/Document/Create" +
                  "?attis_contract_id=" +
                  this.$route.params.id
                : "/Document/Update" +
                  "?attis_contract_id=" +
                  this.document_id),
            formData,
            { headers: { "Content-Type": "multipart/form-data" } },
          )
          .then((response) => {
            console.log(response.data);
            if (response.data.status == "ok") {
              new Noty({
                theme: "light",
                type: "success",
                text: this.$root.$t("message.message.invoice-created"),
                timeout: 5000,
              }).show();
              if (validate && response.data.doc_id !== null) {
                //this.document_id = response.data.doc_id;
                this.$root.$emit("unshow-loading");
                this.buttons_loading = false;
                setTimeout(() => {
                  this.$root.$emit("save-and-validate", response.data.doc_id);
                  //this.current_tab = 0
                  setTimeout(() => {
                    if (document.querySelector("#modal-document") != null)
                      document.querySelector("#modal-document").scrollTo(0, 0);
                    if (document.querySelector("#modal-document-new") != null)
                      document
                        .querySelector("#modal-document-new")
                        .scrollTo(0, 0);
                  }, 500);
                  this.buttons_loading = false;
                }, 500);
              } else {
                this.$root.$emit("loadDocuments", { category: "all" });
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document",
                  "#btnShow",
                );
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document-new",
                  "#btnShow",
                );
                this.buttons_loading = false;
              }
            } else {
              console.info("else case");
              new Noty({
                theme: "light",
                type: "error",
                text:
                  this.$root.$t("message.message.invoice-not-created") +
                  " (" +
                  response.data +
                  ")",
                timeout: 5000,
              }).show();
              if (window.dev_mode) {
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document",
                  "#btnShow",
                );
                this.$root.$emit(
                  "bv::hide::modal",
                  "modal-document-new",
                  "#btnShow",
                );
              }
            }
          })
          .catch((e) => {
            this.buttons_loading = false;
            console.log(e);
            new Noty({
              theme: "light",
              type: "error",
              text: t1,
              timeout: 5000,
            }).show();
            this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
            this.$root.$emit(
              "bv::hide::modal",
              "modal-document-new",
              "#btnShow",
            );
          });
      }
    },
    importGoodsExcel(event, index) {
      if (typeof event.target.files[0] !== "undefined") {
        var fd = new FormData();
        this.files_loading = true;
        fd.append("Files[0]", event.target.files[0]);
        axios
          .post(window.base + "/document/import_excel_goods?type=invoice", fd, {
            headers: { "Content-Type": "multipart/form-data" },
          })
          .then((response) => {
            this.files_loading = false;
            if (response.data !== "error") {
              response.data.forEach((good) => {
                var tmp_good = {};
                //tmp_good.good_guid = good.cgood_guid
                tmp_good = good;
                (tmp_good.good_no = this.InvoiceGoods.length + 1),
                  this.InvoiceGoods.push(tmp_good);
              });
            }
            //this.hideAddProduct();
          });
      }
    },
  },
  mounted() {
    this.fetchCurrencies("");
    this.fetchContragents("");
    this.fetchTNVED("");
    this.fetchMeasures("");
    this.fetchCountries("");

    this.$root.$on("go_to_invoice_error", (error_data) => {
      this.go_to_error(error_data);
    });
    if (this.document_id == "new") {
      var date = new Date();
      this.Invoice.DocumentNumber =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
        "-" +
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1);
      this.Invoice.CurrencyCode = this.contract_details.attis_contract_currency;
      if (this.contract_details.attis_contract_type) {
        this.Invoice.InvoiceSeller =
          this.contract_details.attis_contract_contragent;
        axios.get(window.base + "/document/getfirm").then((response) => {
          this.Invoice.InvoiceByer = {
            value: response.data.org_code,
            display_text: response.data.org_name,
          };
        });
      } else {
        this.Invoice.InvoiceByer =
          this.contract_details.attis_contract_contragent;
        axios.get(window.base + "/document/getfirm").then((response) => {
          this.Invoice.InvoiceSeller = {
            value: response.data.org_code,
            display_text: response.data.org_name,
          };
        });
      }

      if (typeof this.goods !== "undefined")
        this.goods.forEach((good) => {
          var tmp_good = {};
          tmp_good.good_no = good.cgood_no;
          tmp_good.good_guid = good.cgood_guid;
          tmp_good.GoodsCode = good.attis_cg_TNVED;
          tmp_good.GoodsDescription = good.attis_cg_good_name;
          tmp_good.GoodsQuantity = good.attis_cg_quantity;
          tmp_good.SupplementaryQualifierName = good.attis_cg_measures;
          tmp_good.Price = good.attis_cg_price;

          this.InvoiceGoods.push(tmp_good);
        });
    } else {
      this.load();
    }

    // this.$root.$on('saveDocument', (data)=>{
    // 	if(typeof data.document.attis_contract_doc_type === 'object'){
    // 		if(data.document.attis_contract_doc_type.value=='invoice'){
    // 			this.saveDocument(data)
    // 		}
    // 	}else{
    // 		if(data.document.attis_contract_doc_type=='invoce'){
    // 			this.saveDocument(data)
    // 		}
    // 	}
    // })
    this.$root.$on("set.buyer.contragent", (data) => {
      this.Invoice.InvoiceByer = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
    this.$root.$on("set.seller.contragent", (data) => {
      this.Invoice.InvoiceSeller = {
        value: data.company.number,
        display_text: data.company.name,
      };
    });
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
    is_field_readonly() {
      console.log("invoice signed");
      console.log(this.Invoice.IsSigned);
      if (this.Invoice.IsSigned) return true;
      return false;
    },
  },
  watch: {
    Invoice: {
      deep: true,
      handler() {
        var gcost = parseFloat(this.Invoice.GCost);
        var tch = parseFloat(this.Invoice.TransportCharges);
        var ich = parseFloat(this.Invoice.InsuranceCharges);
        var och = parseFloat(this.Invoice.OtherCharges);
        var dscnt = parseFloat(this.Invoice.Discount);

        if (isNaN(gcost)) gcost = 0;
        if (isNaN(tch)) tch = 0;
        if (isNaN(ich)) ich = 0;
        if (isNaN(och)) och = 0;
        if (isNaN(dscnt)) dscnt = 0;
        this.Invoice.TotalCost = gcost + tch + ich + och - dscnt;
      },
    },
    InvoiceGood: {
      deep: true,
      handler() {
        // if(this.percent_focused){
        if (
          parseFloat(this.InvoiceGood.DiscountPercentage) > 0 &&
          !isNaN(parseFloat(this.InvoiceGood.DiscountPercentage))
        ) {
          var qty = parseFloat(this.InvoiceGood.GoodsQuantity);
          var price = parseFloat(this.InvoiceGood.Price);
          var dscp = parseFloat(this.InvoiceGood.DiscountPercentage);
          if (isNaN(qty)) qty = 0;
          if (isNaN(price)) price = 0;
          if (isNaN(dscp)) dscp = 0;
          if (qty > 0)
            this.$set(this.InvoiceGood, "Discount", qty * price * (dscp / 100));
          else this.InvoiceGood.Discount = "";
        }
        // }
      },
    },
    InvoiceGoods: {
      deep: true,
      handler() {
        var sum = 0;
        var gross_weight = 0;
        var net_weight = 0;

        var dscnts = 0;
        var schs = 0;
        var tchs = 0;
        var ochs = 0;
        this.InvoiceGoods.forEach((good) => {
          var qty = parseFloat(good.GoodsQuantity);
          var price = parseFloat(good.Price);
          var dscnt = parseFloat(good.Discount);
          var sch = parseFloat(good.ServiceCharges);
          var tch = parseFloat(good.TransportCharges);
          var och = parseFloat(good.OtherCharges);
          var gw = parseFloat(good.GrossWeightQuantity);
          var nw = parseFloat(good.NetWeightQuantity);

          if (isNaN(qty)) qty = 0;
          if (isNaN(price)) price = 0;
          if (isNaN(dscnt)) dscnt = 0;
          if (isNaN(tch)) tch = 0;
          if (isNaN(sch)) sch = 0;
          if (isNaN(och)) och = 0;
          if (isNaN(gw)) gw = 0;
          if (isNaN(nw)) nw = 0;
          sum += qty * price - dscnt + sch + tch + och;
          dscnts += dscnt;
          schs += sch;
          tchs += tch;
          ochs += och;
          gross_weight += gw;
          net_weight += nw;
          this.Invoice.GCost = sum;
          this.Invoice.GrossWeightQuantity = gross_weight;
          this.Invoice.NetWeightQuantity = net_weight;
          this.Invoice.Discount = dscnts;
          this.Invoice.TransportCharges = tchs;
          this.Invoice.ServiceCharges = schs;
          this.Invoice.OtherCharges = ochs;
        });
      },
    },
  },
  validations: {
    Invoice: {
      DocumentNumber: {
        required,
      },
      DocumentDate: {
        required,
      },
      GCost: {
        required,
      },
      TotalCost: {
        required,
      },
      InvoiceByer: {
        required,
      },
      InvoiceSeller: {
        required,
      },
    },
    InvoiceGood: {
      Price: {
        required,
      },
    },
  },
};
</script>
<style scoped>
#products-table.error {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>
